import React, { useEffect, useState } from "react";
import { formatNumberToCurrency } from "@utils/formatNumber";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import LoaderItem from "../value/accordion/LoaderItem";
import MoneyInput from "@utils/moneyInput";

export const extraValueAppendMutation = (entry) => ({ operation: "append", entry });

export const extraValueActiveMutation = (entry, history, entryIndex) => {
  if (entry?.entryId) {
    return {
      operation: "set_active",
      entryId: entry.entryId,
      expectedActive: entry.isValid,
      active: !entry.isValid,
    };
  }
  return {
    operation: "set_active",
    history: (history || []).map((candidate, index) => (
      index === entryIndex ? { ...candidate, isValid: !candidate.isValid } : { ...candidate }
    )),
  };
};

const renderRow = (label, value) => {
  return <div className="data">
    <span className="accordion-label">{label}</span>
    <span className={`value ${value < 0 ? 'color-red bold' : ''}`}>{isNaN(value) ? value : formatNumberToCurrency(value || 0)}</span>
  </div>
}

const Details = ({ item, onDocumentChange }) => {
  const { updateExtra } = useProjectActions();
  const [newValue, setNewValue] = useState({
    value: 0,
    description: '',
    month: new Date().toISOString().slice(0, 7),
    installments: 1,
    type: 'positive',
    description: ''
  })
  const handleChange = (e) => {
    e.preventDefault()
    const { name, value } = e.target
    setNewValue((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  }

  const handleSend = async () => {
    const firstMonth = newValue.month;
    const installments = parseInt(newValue.installments, 10) || 1;

    const [yearStr, monthStr] = String(firstMonth).split("-");
    const startYear = parseInt(yearStr, 10);
    const startMonth = parseInt(monthStr, 10);

    const totalMonths = startYear * 12 + (startMonth - 1) + (installments - 1);
    const lastYear = Math.floor(totalMonths / 12);
    const lastMonthNum = (totalMonths % 12) + 1;

    const pad = (n) => String(n).padStart(2, "0");
    const lastMonth = `${lastYear}-${pad(lastMonthNum)}`;

    const history = {
      updated_at: new Date().toISOString(),
      value: Number(newValue.type === 'negative' ? -newValue.value : newValue.value),
      installments: newValue.installments,
      installment_value: Number(newValue.value / newValue.installments),
      start_date: firstMonth,
      end_date: lastMonth,
      isValid: true,
      description: newValue.description
    }

    const res = await updateExtra(item.wbs_code_id, extraValueAppendMutation(history), item.description)
    if (res.code === 200) {
      onDocumentChange?.(res.document)
      setNewValue({
        value: 0,
        description: '',
        month: new Date().toISOString().slice(0, 7),
        installments: 1,
      })
    }
  }

  const handleValueChange = (e) => {
    setNewValue((prevValue) => ({
      ...prevValue,
      value: e,
    }));
  };

  return (
    <div className="grid gap-16 align-center" style={{ gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 1fr' }}>
      <div>
        <label>Valor Total:</label>
        <MoneyInput value={newValue.value} onChange={handleValueChange} />
      </div>
      <div>
        <label>Tipo de valor:</label>
        <select onChange={(e) => setNewValue((prev) => ({ ...prev, type: e.target.value }))} value={newValue.type}>
          <option value="positive">
            Despesa
          </option>
          <option value="negative">
            Economia
          </option>
        </select>
      </div>
      <div>
        <label>Descrição:</label>
        <input
          style={{ marginBottom: '0px' }}
          type="text"
          name="description"
          value={newValue.description}
          onChange={handleChange}
          placeholder="Descrição"
        />
      </div>
      <div>
        <label>Mês:</label>
        <input
          style={{ marginBottom: '0px' }}
          type="month"
          name="month"
          value={newValue.month}
          onChange={handleChange}
          placeholder="Mês"
        />
      </div>
      <div>
        <label>Número de parcelas:</label>
        <select onChange={handleChange} name="installments" value={newValue.installments} style={{ marginBottom: '0px' }}>
          {Array.from({ length: 36 }, (_, i) => i + 1).map(num => (
            <option key={num} value={num}>{num} ({formatNumberToCurrency(newValue.value / num)} por parcela)</option>
          ))}
        </select>
      </div>
      <button onClick={handleSend} className="button button-accent">Enviar</button>
    </div>
  );
};

const ExtraValueAccordion = ({ item, isOpen, toggleItem, updateAllCreated }) => {
  const { getExtraValues, updateExtra, getWbsPath } = useProjectActions();
  const { activeProject } = useProjectContext()
  const [items, setItems] = useState([])
  const [values, setValues] = useState([])
  const [status, setStatus] = useState({
    finished: false,
    searched: false
  })
  const [details, setDetails] = useState({})

  const getPath = async () => {
    const id = activeProject.wbs_code_ids.filter(i => item.wbs_code_id.includes(i))[0]
    const wbs = item.wbs_code_id.replace(id, '')
    const res = await getWbsPath(wbs, id)
    setDetails(res.response)
    setValues(res.values)
  }

  useEffect(() => {
    if (isOpen) {
      getPath()
    }
  }, [isOpen])

  const getItems = async () => {
    toggleItem(item.wbs_code_id); // Abre o item
    setStatus({ ...status, searched: true })
    if (!isOpen) {
      const adv = await getExtraValues(activeProject.building_id, item.wbs_code_id)
      setItems(Array.isArray(adv?.response) ? [...adv.response] : []);
    }
    setStatus(prev => { return { ...prev, finished: true } })
  }

  const handleDisable = async (index) => {
    const document = items[0];
    const entry = document?.history?.[index];
    if (!entry) return;
    const response = await updateExtra(
      document.wbs_code_id,
      extraValueActiveMutation(entry, document.history, index),
      document.item_name,
    );
    if (response?.code === 200 && response.document) {
      setItems([response.document]);
      updateAllCreated('replace', response.document);
    }
  };

  const handleDocumentChange = (document) => {
    if (!document) return;
    setItems([document]);
    updateAllCreated('replace', document);
  };

  const getLabel = (label) => {
    switch (label) {
      case 'unit':
        return 'Unidade'
      case 'cell':
        return 'Célula'
      case 'step':
        return 'Etapa'
      case 'substep':
        return 'Subetapa'
      case 'service':
        return 'Serviço'
      default:
        break;
    }
  }

  const Item = ({ item }) => {
    return <div key={item.creditor_name} className="accordion-item">
      <div className="accordion-item-body column-span-1" style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <div className="flex align-center gap-8">
            <button
              className={`accordion-toggle ${isOpen ? "active" : ""}`}
              onClick={getItems}
            ></button>
            <div className="grid">
              <span className="accordion-title">{item.wbs_description}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="margin-left-16 advancement-infos-container">
        {(isOpen && items?.length === 0 && status?.searched && !status.finished) && <LoaderItem />}

        {isOpen && <div>
          {values.budget &&
            <div style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }} className="gap-8 accordion-item-body" >
              {renderRow('Orçado', (values?.budget?.value))}
              {renderRow('Orçado Indexado', (values?.budget?.value_indexed))}
              {renderRow('Previsto', (values?.predicted?.value))}
              {renderRow('Comprometido', (values?.commited?.value))}
              {renderRow('Orçado - Comprometido', (values?.budget?.value - values?.commited?.value))}
            </div>}
          <div style={{ gridTemplateColumns: `repeat(${Object.entries(details).length}, 1fr)` }} className="accordion-item-body margin-bottom-8">
            {details.unit && Object.entries(details).map(([label, value]) => {
              return renderRow(getLabel(label), value)
            })}
          </div>
          {/* {created.length > 0 && created.map(i => {
            return <div key={i._id} className={`accordion-item offcanvas-accordion-item curve margin-bottom-8`}>
              <div className="grid gap-16 columns-5-laptop-l margin-top-12">
                {renderRow(`Descrição`, i.description)}
                {renderRow('Mes(es) referente(s)', `${i.installments > 1 ? `${i.start_date.split('-').reverse().join('/')} - ${i.end_date.split('-').reverse().join('/')}` : i.start_date}`)}
                {renderRow('Valor', formatNumberToCurrency(i.value))}
                {renderRow('Parcelas', `${i.installments} (${formatNumberToCurrency(i.value / i.installments)})`)}
                <button style={{ justifySelf: 'end' }} className="button button-error small" onClick={() => handleDelete(i)}>Deletar</button>
              </div>
            </div>
          })} */}
          {(isOpen && items[0]?.history?.length > 0) &&
            <div className="advancement-items" style={{ display: 'block' }}>
              {items[0]?.history?.map((i, index) => {
                return <div key={i.entryId || `${i.start_date}-${i.end_date}-${i.value}-${i.description || ''}-${i.updated_at || ''}`} className="grid gap-16 columns-6-laptop-l margin-top-12 margin-left-12 margin-bottom-12">
                  {renderRow('Mes(es) referente(s)', `${i.installments > 1 ? `${i.start_date.split('-').reverse().join('/')} - ${i.end_date.split('-').reverse().join('/')}` : i.start_date.split('-').reverse().join('/')}`, i.isValid)}
                  {renderRow('Valor', formatNumberToCurrency(i.value || 0), i.isValid)}
                  {renderRow('Parcelas', `${i.installments} (${formatNumberToCurrency((i.value / i.installments) || 0)})`, i.isValid)}
                  {renderRow('Descrição', i.description || '-', i.isValid)}
                  {renderRow('Criado em', i.updated_at ? new Date(i.updated_at).toLocaleDateString() : '-', i.isValid)}
                  <button className={`button button-${i.isValid ? 'error' : 'green'} small`} style={{ justifySelf: 'end' }} onClick={() => handleDisable(index)}>{i.isValid ? 'Desativar' : 'Ativar'} valor</button>
                </div>
              })}
            </div>}
          <Details item={item} onDocumentChange={handleDocumentChange} />
        </div>}
      </div>
    </div>
  }

  return <Item item={item} />
}

export default ExtraValueAccordion;
